import { parseUnits } from "viem"

import type { TokenStore } from "@/domains/tokens/token-store"
import { LcAddress } from "@/domains/core"

import type { MinimalPoolApiData, MinimalPoolStoreDAO } from "./types"

/**
 * Convert raw API response to Minimal Pool Store DAO
 * Handles address normalization and data transformation
 */
export function convertApiResponseToMinimalPoolStoreDAO(
  apiItem: MinimalPoolApiData,
  token0: TokenStore,
  token1: TokenStore,
): MinimalPoolStoreDAO {
  const gaugeAddress = apiItem.gauge?.address ? new LcAddress(apiItem.gauge.address) : undefined

  const displayName =
    apiItem.displayName ?? `${apiItem.token0?.symbol ?? "Token0"}/${apiItem.token1?.symbol ?? "Token1"}`
  const displayType = apiItem.displayType ?? (apiItem.isStable ? "Stable" : "Volatile")

  return {
    id: apiItem.id,
    address: new LcAddress(apiItem.address),
    apr: apiItem.apr,
    aprLastEpoch: apiItem.aprLastEpoch,
    decimals: apiItem.decimals,
    displayName,
    displayType,
    extendedType: Boolean(apiItem.extendedType) ? apiItem.extendedType : null,
    fee: apiItem.fee,
    gaugeAddress,
    hasGauge: apiItem.hasGauge,
    isStable: apiItem.isStable,
    reserve0: token0?.parseUnits(apiItem.reserve0) ?? 0n,
    reserve1: token1?.parseUnits(apiItem.reserve1) ?? 0n,
    tags: apiItem.tags,
    totalSupply: parseUnits(apiItem.totalSupply, apiItem.decimals) ?? 0n,
    tvlUsd: Number(apiItem.tvlUsd),
    token0: token0,
    token1: token1,
  }
}
